import { Link2 } from 'lucide-react';
import { associationDataString, associationUrl, type AgentAssociationRef } from '@reflex/shared';
import { AssociationChip } from '@reflex/ui/components/shared/AssociationChip';

/**
 * Fallback chip for association kinds with no registered renderer (the
 * owning plugin is uninstalled, or the kind predates its chip). Shows the
 * canonical external id and links to the association's `data.url` when the
 * provider recorded one — enough to stay useful without knowing anything
 * kind-specific.
 */
export function GenericAssociationChip({
  association,
  iconOnly,
}: {
  association: AgentAssociationRef;
  iconOnly?: boolean;
}) {
  const label = association.externalId;
  return (
    <AssociationChip
      href={associationUrl(association)}
      label={label}
      ariaLabel={`Open linked item ${label}`}
      icon={<Link2 className="h-2.5 w-2.5" aria-hidden="true" />}
      hoverSubtitle={associationDataString(association, 'title')}
      hoverDetail="Linked to this agent"
      iconOnly={iconOnly}
      data-testid="generic-association-chip"
    />
  );
}
